var o = Object.defineProperty;
var a = (r, t, e) => t in r ? o(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var s = (r, t, e) => a(r, typeof t != "symbol" ? t + "" : t, e);
import { HttpClient as u, httpClient as n } from "../../httpClient.js";
class p extends u {
  constructor() {
    super(...arguments);
    s(this, "endpoint", "users");
  }
  async searchStudents(e = {}) {
    return n.get("students-new", {
      params: {
        page: e.page ?? 1,
        searchTerm: e.searchTerm || void 0
      }
    });
  }
  async getCurrentUser() {
    return n.get(`${this.endpoint}/current-user`);
  }
  async getLoginStreak() {
    return n.get(
      `${this.endpoint}/current-user/login-streak`
    );
  }
  async downloadEnrollmentVerificationLetter() {
    return n.get(
      `${this.endpoint}/current-user/enrollment-verification-letter`,
      { responseType: "blob" }
    );
  }
  async list() {
    return n.get(this.endpoint);
  }
  async get(e) {
    return n.get(`${this.endpoint}/${e}`);
  }
  async update(e, i) {
    return n.put(`${this.endpoint}/${e}`, i);
  }
  async delete(e) {
    return n.delete(`${this.endpoint}/${e}`);
  }
}
const l = new p();
export {
  l as default
};
